export default "__VITE_PUBLIC_ASSET__04f40989__"